const initialState = {
  admin: null,
  loading: false,
  manager: null,
  toast: null
};

export default initialState;
